<template>
<div style="margin-bottom: 100px">

    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <v-row wrap no-gutters>
            <!-- platform filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Platform</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="platform" :items="platforms" item-value="slug" item-text="name" placeholder="Any" clearable @input="filterItems()" :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                        hide-details />
                </v-card>
            </v-col>
            <!--./ platform filter-->

            <!-- languages filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Show Languages</div>
                    <v-autocomplete class="im-select pa-0 ma-0" :counter="3" :rules="rules" chips multiple flat solo v-model="selected_languages" :items="languages" item-value="code" item-text="name" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                        @input="showLanguages()" hide-details>
                        <template v-slot:selection="data">
                            <v-chip :input-value="data.selected" class="text-uppercase" close small @input="remove(data.item)">
                                {{data.item.code}}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <template>
                                <v-list-item-content>
                                    <v-list-item-title class="text-capitalize"> {{data.item.name}}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </template>
                    </v-autocomplete>
                </v-card>
            </v-col>
            <!--./ languages filter-->
        </v-row>

        <!-- SEARCH -->
        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon medium v-if="$vuetify.breakpoint.smAndDown" class="px-1" @click="dialog_mobile_sort = true">swap_vert
                </v-icon>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn v-for="field in search_fields" :key="field.value" small rounded depressed class="detail mx-1" :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header :items="table_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->

        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;" class="mx-1">
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <im-static-page-item :item="item" :selected_languages="selected_languages" @click.native="seeItem(item)" />
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
    </v-container>

    <!-- add button -->
    <v-btn color="primary" @click="openAddItem()" fab large fixed bottom right>
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add button -->

    <!-- static modal dialog -->
    <v-dialog v-model="edit_dialog" persistent min-height="100%" min-width="100%">
        <im-static-page-modal v-if="static_page" :item="static_page" :selected_languages="selected_languages" @exit="exitEditDialog()" @refresh="getItems()" />
    </v-dialog>
    <!-- static modal dialog -->

    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">
                Sort Items by
            </v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog_mobile_sort = false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->

</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import defaults from "../components/utils/PropDefaults.js"
import IMStaticItem from '../components/items/StaticPageCard.vue'
import IMUserSearch from '../components/utils/UserSearch.vue'
import IMTableHeader from '../components/utils/IMTableHeader.vue';
import IMSortField from "../components/utils/IMSortField.vue";
import IMStaticPageModal from '../components/items/StaticPageModal.vue'
import TipTap from "../components/utils/TipTap.vue";

export default {

    name: `ratings`,

    components: {
        'im-table-header': IMTableHeader,
        "im-sort-filed": IMSortField,
        'im-static-page-item': IMStaticItem,
        'im-static-page-modal': IMStaticPageModal,
        'im-user-search': IMUserSearch,
        'tip-tap': TipTap,
    },

    data() {
        return {

            platforms: [],
            platform: null,
            selected_languages: ["ro"],
            identifier_lang: [],
            languages: [],
            current_rating: defaults.rating_item,

            // dialogs
            delete_dialog: false,
            dialog_static_page: false,
            edit_dialog: false,
            dialog_mobile_sort: false,

            // search
            search: null,
            search_timeout: 300,

            // table items
            static_page: this.$clone(defaults.one_static_pages),

            items: [],
            im_header: [],
            search_fields: [
                {
                    text: 'Platform',
                    value: 'platforms.name',
                    selected: false
                }, {
                    text: 'Title',
                    value: 'title',
                    selected: false
                }, {
                    text: 'Slug',
                    value: 'slug',
                    selected: false
                }, {
                    text: 'Body',
                    value: 'body',
                    selected: false
                },
            ],

            rules: [(v) => v && v.length <= 3 || 'max 3'],
            // table attributes
            loading: null,
            is_saving: false,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],
        }
    },

    watch: {

        page: {
            handler() {
                this.getItems()
            }
        },
        size: {
            handler() {
                this.getItems()
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500)
            }
        },

    },

    computed: {
        table_header: function () {
            let header = [{
                text: "Platform / Slug",
                sortable: true,
                align: "center",
                width: "30%"
        }];
            let col = this.selected_languages.length;
            let width = Math.round(70 / col);
            this.selected_languages.forEach(lang => {
                header.push({
                    text: lang,
                    sortable: false,
                    align: "center",
                    width: width + "%"
                })
            });
            return header;
        }
    },

    created() {
        this.getItems();
        this.getPlatforms();
        this.getLanguages();
    },

    mounted() {
        window.document.title = 'Static Pages';
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }
            // prepare platform filter
            let platform = this.platform;
            if(platform === "" || platform === undefined) {
                platform = null;
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });
            // setup query params
            let params = {
                params: {
                    app_slug: platform,
                    search: search,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    languages: ['ro', 'en']
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/pages';

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.items = response.data.data;
                    this.total = response.data.pagination.total;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        seeItem(current_item) {
            this.static_page = this.$clone(current_item);
            this.edit_dialog = true;
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

        showLanguages() {
            while(this.selected_languages.length > 3) {
                this.selected_languages.splice(-1, 1);
            }
            if(this.selected_languages.length < 4) {
                this.filterItems();
            }
        },

        languageSelected(value) {
            let item = this.languages.filter(language => language.code === value);
            if(item.length > 0) {
                return item[0].name;
            }
        },

        remove(item) {
            const index = this.selected_languages.indexOf(item.code);
            if(index >= 0) this.selected_languages.splice(index, 1);
            // this.getItems();
        },

        removeFromDialog(item) {
            const index = this.identifier_lang.findIndex(lang => lang.code === item.code);
            if(index >= 0) this.identifier_lang.splice(index, 1);
            // this.getItems();
        },

        getPlatforms() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/platforms';

            this.$axios.get(endpoint)
                .then(response => {
                    this.platforms = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        getLanguages() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/languages';

            this.$axios.get(endpoint)
                .then(response => {
                    this.languages = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        filterItems() {
            this.page = 1;
            this.getItems();
        },

        openAddItem() {
            this.static_page = this.$clone(defaults.static_page_item);
            this.edit_dialog = true;
        },

        exitEditDialog() {
            this.static_page = this.$clone(defaults.static_page_item);
            this.edit_dialog = false;
        }

    }

}
</script>
